import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { LanguageService } from './common/services/language.service';
import { AuthAppService } from './modules/auth';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        private authService: AuthAppService,
        private translocoService: TranslocoService,
        private languageService: LanguageService
    ) { }

    ngOnInit(): void {
        // S'abonner aux changements de langue
        this.languageService.langChanged$.subscribe(lang => {
            if (this.translocoService.getActiveLang() !== lang) {
                this.translocoService.setActiveLang(lang);
            }
        });
    }
}
